module.exports = __webpack_public_path__ + "img/HEART.164589d2.png";